import { RegularIconNames, Message, useDesignLanguagePerClass, useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { useCheckoutState, useHasBillingAgreements, useIsBillingAgreementApprovalProcess } from '../../state'

import styles from './style.module.css'
import { useTranslation } from '../../utils/convergence'

export const BillingAgreementMessage: FunctionComponent = () => {
  const { t } = useTranslation()
  const { checkout } = useCheckoutState()
  const hasBillingAgreements = useHasBillingAgreements()
  const isBillingAgreementApprovalProcess = useIsBillingAgreementApprovalProcess()
  const designLanguageClass = useDesignLanguagePerClass(styles)
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const iconName: RegularIconNames = isArcadeDesignLanguage ? 'InformationFill' : 'Info'

  return (
    <>
      {(hasBillingAgreements || isBillingAgreementApprovalProcess) && (
        <div className={designLanguageClass.wrapper}>
          <Message
            iconName={iconName}
            kind='Basic'
            description={t('summary:recurringPaymentMessage.description', {
              merchantName: checkout?.merchant?.name,
            })}
            testNameSpace='recurring-payment'
          />
        </div>
      )}
    </>
  )
}
